<script setup lang="ts">
import type { ButtonColor, ButtonRounded, ButtonSize, ButtonVariant } from '@/types';
import BaseButton from './BaseButton.vue';
import BaseIcon from './BaseIcon.vue';

const props = withDefaults(defineProps<{
  color?: ButtonColor
  variant?: ButtonVariant
  size?: ButtonSize
  rounded?: ButtonRounded
  disabled?: boolean
  tooltip?: string
  square?: boolean
}>(), {
  color: 'primary',
  variant: 'flat',
  size: 'md',
  rounded: 'full',
  disabled: false,
  tooltip: '',
  square: true // Default to true for icon buttons
});

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
}>();

const handleClick = (event: MouseEvent) => {
  emit('click', event);
};
</script>

<template>
  <BaseButton 
    :color="color"
    :variant="variant" 
    :size="size" 
    :rounded="rounded" 
    :disabled="disabled"
    :tooltip="tooltip"
    :square="square"
    @click="handleClick"
  >
    <template #icon>
      <BaseIcon :size="props.size">
        <slot></slot>
      </BaseIcon>
    </template>
  </BaseButton>
</template> 